// extracted by mini-css-extract-plugin
export var blockBtn = "hero-module--block-btn--5306f";
export var hero = "hero-module--hero--9f6b8";
export var hero__button = "hero-module--hero__button--0baca";
export var hero__element = "hero-module--hero__element--c817b";
export var hero__elementOne = "hero-module--hero__element--one--b7d36";
export var hero__elementTwo = "hero-module--hero__element--two--a5c5a";
export var hero__list = "hero-module--hero__list--b1cd2";
export var hero__presentation = "hero-module--hero__presentation--edbd4";
export var hero__subtitle = "hero-module--hero__subtitle--f980c";
export var hero__text = "hero-module--hero__text--3cc84";
export var hero__textSmall = "hero-module--hero__text--small--d6e28";
export var hero__title = "hero-module--hero__title--965eb";
export var hero__wrapper = "hero-module--hero__wrapper--d329c";
export var mainBtn = "hero-module--main-btn--2358f";
export var mainTitle = "hero-module--main-title--4fe3b";
export var title = "hero-module--title--6e8b0";